module.exports = __webpack_public_path__ + "static/qcv_center.4ed9d66d.jpg";